import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./profile.css";
import { getProfile, updateProfile } from "../../service/auth_service.js";
import ApiRoutes from "../../utils/api_routes.js";

function EmployeeProfile() {
  const [formData, setFormData] = useState({
    employeeid: "",
    employeename: "",
    mobilenumber: "",
    profileimage: null,
    email: "",
    designation: "",
    joiningdate: "",
    role: "",
    dateofbirth: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "profileimage") {
      const file = files[0];

      setFormData((prev) => ({
        ...prev,
        profileimage: file,
      }));

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.readAsDataURL(file);
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const data = new FormData();

      data.append("employeename", formData.employeename);
      data.append("mobilenumber", formData.mobilenumber);
      data.append("dateofbirth", formData.dateofbirth);

      if (formData.profileimage) {
        data.append("profileimage", formData.profileimage);
      }

      const response = await updateProfile(data);

      if (response.status === "success") {
        toast.success("Profile updated successfully");
        getProfileData();
      } else {
        toast.error(response.message || "Update failed");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const getProfileData = async () => {
    try {
      const response = await getProfile();

      if (response.status === "success" && response.data) {
        const data = response.data;

        setFormData({
          employeeid: data.employeeid || "",
          employeename: data.employeename || "",
          mobilenumber: data.mobilenumber || "",
          profileimage: null,
          email: data.email || "",
          designation: data.designation || "",
          joiningdate: data.joiningdate || "",
          role: data.role || "",
          dateofbirth: data.dateofbirth || "",
        });

        const profileUrl = data.profile ? ApiRoutes.baseUrl + data.profile : null;
        setImagePreview(profileUrl);

        // Update localStorage for Header reflection
        localStorage.setItem("user_name", data.employeename || "");
        localStorage.setItem("user_profile", profileUrl || "");

        // Dispatch event for immediate Header reflection
        window.dispatchEvent(new Event("profileUpdated"));
      } else {
        toast.error(response.message || "Failed to fetch profile data");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <div className="profile-container">
      <h4>My Profile</h4>

      <div className="profile-image-section">
        {imagePreview ? (
          <img src={imagePreview} alt="Profile" className="profile-image" />
        ) : (
          <div className="profile-placeholder"></div>
        )}

        <input
          type="file"
          name="profileimage"
          onChange={handleChange}
          accept=".png, .jpg, .jpeg"
          className="profile-upload"
        />
      </div>

      <div className="profile-card">
        <form className="profile-form" onSubmit={handleSubmitForm}>
          <div className="profile-form-group">
            <label>Name</label>
            <input
              type="text"
              name="employeename"
              placeholder="Enter Name"
              value={formData.employeename}
              onChange={handleChange}
              required
            />
          </div>

          <div className="profile-form-group">
            <label>Phone Number</label>
            <input
              type="text"
              name="mobilenumber"
              placeholder="Enter Phone Number"
              value={formData.mobilenumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="profile-form-group">
            <label>Date of Birth</label>
            <input
              type="date"
              name="dateofbirth"
              value={formData.dateofbirth}
              onChange={handleChange}
            />
          </div>

          <div className="profile-form-group">
            <label>Email</label>
            <input type="text" value={formData.email} disabled />
          </div>

          <div className="profile-form-group">
            <label>Designation</label>
            <input type="text" value={formData.designation} disabled />
          </div>

          <div className="profile-form-group">
            <label>Position</label>
            <input type="text" value={formData.role} disabled />
          </div>

          <div className="profile-form-group">
            <label>Joining Date</label>
            <input type="text" value={formData.joiningdate} disabled />
          </div>
        </form>
        <div className="profile-buttons">
          <button
            type="submit"
            className="apply-btn"
            onClick={handleSubmitForm}
            disabled={loading}
          >
            {loading ? "Loading..." : "Update Profile"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EmployeeProfile;
